import exchangeApi from '../../api/exchange-api';
const EXCHANGE_RATE_SET_VERSION = 'EXCHANGE_RATE_SET_VERSION';
const EXCHANGE_RATE_SET_FOREIGN_TYPE = 'EXCHANGE_RATE_SET_FOREIGN_TYPE';
const EXCHANGE_RATE_SET_CURRENCIES = 'EXCHANGE_RATE_SET_CURRENCIES';
const EXCHANGE_RATE_SET_CURRENCIES_FOR_DOWNLOAD = 'EXCHANGE_RATE_SET_CURRENCIES_FOR_DOWNLOAD';
const EXCHANGE_RATE_GET_VERSIONS_REQUEST = 'EXCHANGE_RATE_GET_VERSIONS_REQUEST';
const EXCHANGE_RATE_GET_VERSIONS_SUCCESS = 'EXCHANGE_RATE_GET_VERSIONS_SUCCESS';
const EXCHANGE_RATE_TECHNICAL_FAILURE = 'EXCHANGE_RATE_TECHNICAL_FAILURE';
const EXCHANGE_RATE_SET_DATE = 'EXCHANGE_RATE_SET_DATE';
const EXCHANGE_RATE_GET_MESSAGES = 'EXCHANGE_RATE_GET_MESSAGES';

const exchangeRateState = {
	loading: false,
	technicalError: false,
	version: null,
	versionInfo: null,
	results: null,
	date: null,
	currencies: null,
	currenciesForDownload: null,
	foreignType: null,
	messages: null
};

const exchangeRateActions = {
	getCurrencies({ commit }) {
		exchangeApi
			.getCurrencies()
			.then((response) => {
				let currenciesForDownload = response.data.currencies.filter((currency) => currency.currencyCode != 'HUF');
				commit(EXCHANGE_RATE_SET_CURRENCIES, response.data);
				commit(EXCHANGE_RATE_SET_CURRENCIES_FOR_DOWNLOAD, currenciesForDownload);
			})
			.catch(() => {
				commit(EXCHANGE_RATE_TECHNICAL_FAILURE);
			});
	},
	getVersions({ commit }, { type, date }) {
		let functionName = {
			exchange: 'getExchangeVersions',
			MNB: 'getMNBVersions',
			foreignIndividual: 'getForeignIndividualVersions',
			foreignStandard: 'getForeignStandardVersions'
		};
		commit(EXCHANGE_RATE_GET_VERSIONS_REQUEST);
		exchangeApi[functionName[type]](date)
			.then((response) => {
				let versions = response.data.dates[0].versions.sort((a, b) => b.version - a.version);
				response.data.dates[0].versions = versions;
				commit(EXCHANGE_RATE_GET_VERSIONS_SUCCESS, response.data.dates[0]);
			})
			.catch(() => {
				commit(EXCHANGE_RATE_TECHNICAL_FAILURE);
			});
	},
	setVersion({ commit }, version) {
		commit(EXCHANGE_RATE_SET_VERSION, version);
	},
	setForeignType({ commit }, foreignType) {
		commit(EXCHANGE_RATE_SET_FOREIGN_TYPE, foreignType);
	},
	setDate({ commit }, date) {
		commit(EXCHANGE_RATE_SET_DATE, date);
	},
	setTechnicalError({ commit }) {
		commit(EXCHANGE_RATE_TECHNICAL_FAILURE);
	},
	getMessages({ commit }, keys) {
		exchangeApi
			.getMessages(keys)
			.then((response) => {
				let messages = {};
				for (let item of response.data) {
					if (!messages[item.exchangeRateType]) {
						messages[item.exchangeRateType] = {};
					}
					messages[item.exchangeRateType][item.messageType] = item.message;
				}
				commit(EXCHANGE_RATE_GET_MESSAGES, messages);
			})
			.catch(() => {
				commit(EXCHANGE_RATE_TECHNICAL_FAILURE);
			});
	}
};

const exchangeRateMutations = {
	[EXCHANGE_RATE_TECHNICAL_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[EXCHANGE_RATE_GET_VERSIONS_SUCCESS](state, versionInfo) {
		state.versionInfo = versionInfo;
	},
	[EXCHANGE_RATE_GET_VERSIONS_REQUEST](state) {
		state.loading = true;
	},
	[EXCHANGE_RATE_SET_VERSION](state, version) {
		state.version = version;
	},
	[EXCHANGE_RATE_SET_FOREIGN_TYPE](state, foreignType) {
		state.foreignType = foreignType;
	},
	[EXCHANGE_RATE_SET_DATE](state, date) {
		state.date = date;
	},
	[EXCHANGE_RATE_SET_CURRENCIES](state, currencies) {
		state.currencies = currencies;
	},
	[EXCHANGE_RATE_SET_CURRENCIES_FOR_DOWNLOAD](state, currencies) {
		state.currenciesForDownload = currencies;
	},
	[EXCHANGE_RATE_GET_MESSAGES](state, messages) {
		state.messages = messages;
	}
};

export default {
	namespaced: true,
	state: exchangeRateState,
	mutations: exchangeRateMutations,
	actions: exchangeRateActions
};
